import React, { Component } from 'react';
import resources from '../../resources';
import StoreManager from '../../appdata';

class CorporateStructureContent extends Component {
  render() {
    
        const lang = StoreManager.appState.thisApp.state.currentLanguage;
    
    return (
      <div style={{ padding: '24px 16px', textAlign: 'center' }}>
        <img
          src={lang == 'vi' ? resources.images.CorporateStructureImage1_vi: resources.images.CorporateStructureImage1}
          alt="Corporate Structure"
          style={{ maxWidth: '100%', height: 'auto', borderRadius: 12 }}
        />
      </div>
    );
  }
}

export default CorporateStructureContent;
